import axios from 'axios';

const list = (data) => axios.get('/safe/ai/list2', data);
const save = (data) => axios.post('/safe/ai/save', data);
const del = (data) => axios.post('/safe/ai/delete', data);

const genreSave = (data) => axios.post('/safe/genre/save', data);
const genreDel = (data) => axios.post('/safe/genre/delete', data);


export default {
  list,
  save,
  del,
  genreSave,
  genreDel,

}


